// Money and percent formatters of the fees modal

// From here the wager is shown as $1M, $2.5M
const COMPACT_MONEY_FROM = 1000000;

/** "$1,500" / "$2.5": up to 2 decimals, none for whole amounts */
export const formatWholeMoney = (value) =>
  `$${value.toLocaleString("en-US", { maximumFractionDigits: 2 })}`;

/** "$1K", "$2.5M", as the leveraged wager size in the design */
export const formatCompactMoney = (value) =>
  `$${value.toLocaleString("en-US", {
    notation: "compact",
    maximumFractionDigits: 2,
  })}`;

/** Wager slider value: whole amounts, compact from $1M */
export const formatWagerStep = (value) =>
  value >= COMPACT_MONEY_FROM
    ? formatCompactMoney(value)
    : formatWholeMoney(value);

/** "+1.00%", "-0.50%", "0.00%" */
export const formatPriceMove = (value) =>
  `${value > 0 ? "+" : ""}${value.toFixed(2)}%`;
